//import UsersDB from './users-db';
//import firebase from 'firebase/app';
//import "firebase/firestore";
//import * as firebaseui from 'firebaseui';
//import "firebase/auth";
import * as htmlBuilder from '../htmlBuilder';
//import { getFunctions } from 'firebase/functions'; // Commented out - using Firebase v8 syntax instead
//import HtmlWebpackPlugin from 'html-webpack-plugin';

function mySignOut() {
    settings.globals.firebase.currentUserID = null;
    // COMMENTED OUT: Subscription check removed - system now uses authentication-only access control
    // Previously reset subscription status on sign out:
    // settings.globals.firebase.activeSubscription = false;
    if (settings.globals.firebase.firebaseApp) {
        settings.globals.firebase.firebaseApp.auth().signOut();
        // NEW: After sign out, handleLogout will be called by onAuthStateChanged listener
        // which will hide content and show login screen (handled automatically)
    }
}

/**
 * Initialize Firebase and return a Promise that resolves when initial auth state is known
 * COMMENTED OUT: Previous synchronous version - now returns Promise to enable mandatory login check
 * Previously: Function had no return value, auth state was checked asynchronously via onAuthStateChanged
 * Now: Returns Promise so initialization can wait for auth state before showing content
 */
function initFirebase() {
    // Initialize Firebase if need be
    if (!settings.globals.firebase.firebaseApp) {
        // Replace with your Firebase project config.
        const firebaseConfig = {
            apiKey: 'AIzaSyDhcSE0mm2w_y8AYr1GdANlX7lxMEaaRWk',
            authDomain: 'oneworld-futbol.firebaseapp.com',
            databaseURL: 'https://oneworld-futbol.firebaseio.com',
            projectId: 'oneworld-futbol',
            storageBucket: 'oneworld-futbol.appspot.com',
            messagingSenderId: '100814520643',
            appId: '1:100814520643:web:f894a098ea65d5b668aff6',
            measurementId: 'G-CT6HN3LW27',
        };
        settings.globals.firebase.firebaseApp = firebase.initializeApp(firebaseConfig); //firebase seems to be global
        settings.globals.firebase.UI = new firebaseui.auth.AuthUI(firebase.auth());
        settings.globals.firebase.db = settings.globals.firebase.firebaseApp.firestore();

        // Ensure uiConfig is set after Firebase initialization
        if (!settings.globals.firebase.uiConfig) {
            settings.globals.firebase.uiConfig = createUiConfig();
        }

        // NEW: Force logout on page load to require login each time
        // This clears any persisted authentication session from localStorage
        // COMMENTED OUT: Previous behavior - allowed persistent sessions across page reloads
        // Previously: Firebase would automatically restore user session from localStorage,
        // allowing users to stay logged in across browser sessions
        // Now: Force logout on every page load to require fresh login each time
        // This is useful for testing/development and ensures users must authenticate each visit
        return firebase
            .auth()
            .signOut()
            .then(() => {
                console.log('Forced logout on page load - user must log in');
            })
            .catch((error) => {
                // If signOut fails (e.g., no user was logged in), continue anyway
                console.log('No user to sign out, or signOut error:', error);
            })
            .then(() => {
                // After signOut completes (or fails), set up auth state listener
                // Return a Promise that resolves when initial auth state is known (after logout)
                return new Promise((resolve) => {
                    const unsubscribe = firebase.auth().onAuthStateChanged((firebaseUser) => {
                        //this runs asynchronously
                        // Unsubscribe after first auth state is known
                        unsubscribe();

                        if (firebaseUser) {
                            console.log('firebaseUser set');
                            // document.querySelector('#loader').style.display = 'none';
                            settings.globals.firebase.currentUserID = firebaseUser.uid;
                            // COMMENTED OUT: Subscription check removed - system now uses authentication-only access control
                            // Previously checked for active Stripe subscription when user signed in:
                            // checkStripeSubscription(false, false); //this has an async call in it
                            htmlBuilder.replaceUserDependentMenu();
                        } else {
                            settings.globals.firebase.currentUserID = null;
                            // COMMENTED OUT: Subscription check removed - system now uses authentication-only access control
                            // Previously reset subscription status when user signed out:
                            // settings.globals.firebase.activeSubscription = false;
                            htmlBuilder.replaceUserDependentMenu();
                        }

                        // Resolve promise once initial auth state is known
                        resolve(firebaseUser);
                    });

                    // Also set up ongoing auth state listener for future changes (after initial check)
                    firebase.auth().onAuthStateChanged((firebaseUser) => {
                        if (firebaseUser) {
                            console.log('firebaseUser set (ongoing listener)');
                            settings.globals.firebase.currentUserID = firebaseUser.uid;
                            htmlBuilder.replaceUserDependentMenu();
                            // If content was hidden and user just logged in, show content and initialize if needed
                            handlePostLoginInitialization();
                        } else {
                            settings.globals.firebase.currentUserID = null;
                            htmlBuilder.replaceUserDependentMenu();
                            // If user logs out, hide content and show login
                            handleLogout();
                        }
                    });
                });
            });
    } else {
        // Firebase already initialized, return resolved promise with current user
        const currentUser = settings.globals.firebase.firebaseApp.auth().currentUser;
        // Ensure uiConfig is set even if Firebase was already initialized
        if (!settings.globals.firebase.uiConfig) {
            settings.globals.firebase.uiConfig = createUiConfig();
        }
        return Promise.resolve(currentUser);
    }
}

/**
 * Create and return the Firebase UI configuration
 * Extracted to a separate function so it can be reused
 */
function createUiConfig() {
    return {
        //was const firebaseUiConfig = {
        callbacks: {
            signInSuccessWithAuthResult: function (authResult, redirectUrl) {
                // User successfully signed in.
                // Return type determines whether we continue the redirect automatically
                // or whether we leave that to developer to handle.
                settings.globals.firebase.currentUserID = authResult.user.uid;
                document.querySelector('#myFirebaseUI-Container').style.display = 'none';
                // document.querySelector('#firebaseui-auth-container').style.display = 'none';
                // COMMENTED OUT: Subscription-based redirect removed - system now uses authentication-only
                // Previously redirected to subscription layer after login:
                // htmlBuilder.switchModes(settings.layerIndices.subscribeLayerIndex); //serves as a callback
                // NEW: After login, redirect to the callback layer if set, otherwise show logged in message
                if (settings.globals.firebase.callBackLayerIndex !== null) {
                    htmlBuilder.switchModes(settings.globals.firebase.callBackLayerIndex);
                } else {
                    htmlBuilder.switchModes(settings.layerIndices.logInLayerIndex); // Show logged in confirmation
                }
                return false; //false means do not redirect
            },
            signInFailure: function (error) {
                // Handle sign-in failures
                console.error('Sign-in error:', error);
            },
            uiShown: function () {
                hideSpinner();
            },
        },
        signInFlow: 'popup',
        signInSuccessUrl: '/',
        // Removed EmailAuthProvider.PROVIDER_ID - using custom email/password form instead to prevent sign-up
        // Removed Google sign-in - only using custom email/password form
        signInOptions: [], // Empty array - no FirebaseUI providers, only custom email/password form
        credentialHelper: firebaseui.auth.CredentialHelper.NONE,
        // Your terms of service url.
        tosUrl: 'https://OneWorld-Futbol.com/docs/termsOfUse.html',
        // Your privacy policy url.
        privacyPolicyUrl: 'https://OneWorld-Futbol.com/docs/privacyPolicy.html',
    };
}

function checkStripeSubscription(continueToSubscribe, callBack) {
    console.log('checkStripeSubscription');
    settings.globals.firebase.activeSubscription = false;
    if (settings.globals.firebase.currentUserID) {
        settings.globals.firebase.db
            .collection('users') //was customers
            .doc(settings.globals.firebase.currentUserID) //was .doc(currentUser)
            .collection('subscriptions')
            .where('status', 'in', ['active']) //was ['trialing', 'active'])
            .onSnapshot(async (snapshot) => {
                if (snapshot.empty) {
                    if (continueToSubscribe) startSubscriptionProcess();
                } else {
                    settings.globals.firebase.activeSubscription = true;
                    if (callBack) switchModes(settings.globals.firebase.callBackLayerIndex);
                }
                htmlBuilder.replaceUserDependentMenu(); //whatever the result of the async call, update the menu
            });
    }
}

/**
 * Custom email/password sign-in function (sign-in only, no sign-up)
 */
function handleEmailPasswordSignIn(email, password) {
    showSpinner();
    if (!settings.globals.firebase.firebaseApp) {
        console.error('Firebase not initialized');
        hideSpinner();
        return Promise.reject(new Error('Firebase not initialized'));
    }

    return settings.globals.firebase.firebaseApp
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
            // Sign-in successful - this will trigger onAuthStateChanged
            settings.globals.firebase.currentUserID = userCredential.user.uid;
            document.querySelector('#myFirebaseUI-Container').style.display = 'none';
            hideSpinner();
            // COMMENTED OUT: Previous version called switchModes immediately after login
            // Previously: Tried to switch modes immediately, but map wasn't initialized yet, causing "eachLayer" error
            // if (settings.globals.firebase.callBackLayerIndex !== null) {
            //     htmlBuilder.switchModes(settings.globals.firebase.callBackLayerIndex);
            // } else {
            //     htmlBuilder.switchModes(settings.layerIndices.logInLayerIndex); // Show logged in confirmation
            // }
            // NEW: Don't call switchModes here - let onAuthStateChanged handler in initialization.js
            // handle the full initialization (map setup, etc.) before switching modes
            // The handlePostLoginInitialization() function will be called by onAuthStateChanged
            // which will trigger the initialization flow that includes map setup
            console.log('Sign-in successful, waiting for initialization to complete');
            return userCredential;
        })
        .catch((error) => {
            hideSpinner();
            // Display error message to user
            const errorContainer = document.querySelector('#custom-login-error');
            if (errorContainer) {
                let errorMessage = 'Sign-in failed. ';
                if (error.code === 'auth/user-not-found') {
                    errorMessage += 'No account found with this email.';
                } else if (error.code === 'auth/wrong-password') {
                    errorMessage += 'Incorrect password.';
                } else if (error.code === 'auth/invalid-email') {
                    errorMessage += 'Invalid email address.';
                } else if (error.code === 'auth/too-many-requests') {
                    errorMessage += 'Too many failed attempts. Please try again later.';
                } else {
                    errorMessage += error.message || 'Please check your credentials and try again.';
                }
                errorContainer.textContent = errorMessage;
                errorContainer.style.display = 'block';
            }
            return Promise.reject(error);
        });
}

function handleLogInAndSubscribe() {
    console.log('handleLogInAndSubscribe called');
    /**
     * Firebase Authentication configuration
     */
    if (!settings.globals.firebase.currentUserID) {
        //case I not logged in
        const loginContainer = document.querySelector('#myFirebaseUI-Container');
        if (loginContainer) {
            loginContainer.style.display = 'block';
            console.log('✓ Login container displayed in handleLogInAndSubscribe');
        } else {
            console.error('✗ Login container not found in handleLogInAndSubscribe');
        }

        // Set up custom email/password sign-in form (sign-in only, no sign-up)
        const customLoginForm = document.querySelector('#custom-login-form');
        if (customLoginForm) {
            // Remove any existing event listeners by cloning and replacing
            const newForm = customLoginForm.cloneNode(true);
            customLoginForm.parentNode.replaceChild(newForm, customLoginForm);

            // Add event listener to the new form
            newForm.addEventListener('submit', function (e) {
                e.preventDefault();
                const email = document.querySelector('#custom-login-email').value;
                const password = document.querySelector('#custom-login-password').value;

                // Hide any previous error messages
                const errorContainer = document.querySelector('#custom-login-error');
                if (errorContainer) {
                    errorContainer.style.display = 'none';
                }

                handleEmailPasswordSignIn(email, password)
                    .then(() => {
                        // Success - onAuthStateChanged will handle the rest
                        console.log('Sign-in successful');
                    })
                    .catch((error) => {
                        // Error handling is done in handleEmailPasswordSignIn
                        console.error('Sign-in error:', error);
                    });
            });
        }

        // Only start FirebaseUI if there are sign-in options (e.g., Google)
        // Email/password handled by custom form
        if (
            settings.globals.firebase.uiConfig &&
            settings.globals.firebase.uiConfig.signInOptions &&
            settings.globals.firebase.uiConfig.signInOptions.length > 0
        ) {
            settings.globals.firebase.UI.start('#firebaseui-auth-container', settings.globals.firebase.uiConfig);
        }
    } else {
        // COMMENTED OUT: Subscription check removed - system now uses authentication-only access control
        // Previously checked for active Stripe subscription when user was already logged in:
        // If subscription existed, it would proceed to subscription check and callback handling
        // checkStripeSubscription(true, true);
        // User is already logged in - proceed to their requested destination
        // The onAuthStateChanged callback will handle updating the UI
        htmlBuilder.replaceUserDependentMenu();
    }
}

function startSubscriptionProcess() {
    const prices = {};
    // Replace with your cloud functions location
    document.querySelector('#subscribe').style.display = 'block';
    // Get all our products and render them to the page
    const products = document.querySelector('.products'); //querySelector only returns one
    const template = document.querySelector('#product');
    settings.globals.firebase.db
        .collection('products')
        .where('active', '==', true)
        .get()
        .then(function (querySnapshot) {
            querySnapshot.forEach(async function (doc) {
                const priceSnap = await doc.ref
                    .collection('prices')
                    .where('active', '==', true)
                    .orderBy('unit_amount', 'asc')
                    .get();
                if (!('content' in document.createElement('template'))) {
                    return; //exit
                }
                const product = doc.data();
                let thePrice = null;
                // Prices dropdown
                priceSnap.docs.forEach((doc) => {
                    // even though the dropdown is disabled the content is still filled in
                    const container = template.content.cloneNode(true);
                    const priceId = doc.id;
                    const priceData = doc.data();
                    prices[priceId] = priceData;
                    let theText = '';
                    if (priceData.interval_count === 1) {
                        theText = `${new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: priceData.currency,
                        }).format((priceData.unit_amount / 100).toFixed(2))} per ${priceData.interval ?? 'once'}`;
                    } else {
                        theText = `${new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: priceData.currency,
                        }).format((priceData.unit_amount / 100).toFixed(2))} for ${priceData.interval_count}  ${
                            priceData.interval
                        }s`;
                    }
                    container.querySelector('.description').innerText = theText;
                    const option = document.createElement('option');
                    option.value = priceId;
                    //option.appendChild(content);
                    container.querySelector('#price').appendChild(option);
                    const form = container.querySelector('form');
                    form.addEventListener('submit', subscribe);
                    products.appendChild(container);
                });
            });
        });

    /*
    Event listeners
    don't see the need for a signout button
    // Signout button
    document
      .getElementById('signout')
      .addEventListener('click', () => {
        firebase.auth().signOut();
      }
      ); */

    // Checkout handler
    async function subscribe(event) {
        showSpinner();
        event.preventDefault();
        document.querySelectorAll('button').forEach((b) => (b.disabled = true));
        const formData = new FormData(event.target);
        const selectedPrice = {
            price: formData.get('price'),
        };
        // For prices with metered billing we need to omit the quantity parameter.
        // For all other prices we set quantity to 1.
        if (prices[selectedPrice.price]?.recurring?.usage_type !== 'metered') selectedPrice.quantity = 1;
        const checkoutSession = {
            automatic_tax: true,
            tax_id_collection: true,
            collect_shipping_address: false,
            allow_promotion_codes: true,
            line_items: [selectedPrice],
            success_url: 'https://OneWorld-Futbol.com',
            cancel_url: 'https://OneWorld-Futbol.com',
            metadata: {
                key: 'value',
            },
        };
        // For one time payments set mode to payment.
        if (prices[selectedPrice.price]?.type === 'one_time') {
            checkoutSession.mode = 'payment';
            checkoutSession.payment_method_types = ['card', 'sepa_debit', 'sofort'];
        }

        const docRef = await settings.globals.firebase.db
            .collection('users') //was customers
            .doc(settings.globals.firebase.currentUserID) //was .doc(currentUser)
            .collection('checkout_sessions')
            .add(checkoutSession);
        // Wait for the CheckoutSession to get attached by the extension
        docRef.onSnapshot((snap) => {
            //might need to be async
            const { url, error } = snap.data();
            if (error) {
                // Show an error to your customer and then inspect your function logs.
                alert(`An error occured: ${error.message}`);
                document.querySelectorAll('button').forEach((b) => (b.disabled = false));
            } else if (url) {
                hideSpinner();
                window.location.assign(url);
            }
        });
    }

    // Get custom claim role helper
    /*  async function getCustomClaimRole() {
         await firebase.auth().currentUser.getIdToken(true);
         const decodedToken = await firebase.auth().currentUser.getIdTokenResult();
         return decodedToken.claims.stripeRole;
     } */
}

function showSpinner() {
    document.querySelector('html').setAttribute('data-spinnerNeeded', 'true');
}

function hideSpinner() {
    document.querySelector('html').setAttribute('data-spinnerNeeded', 'false');
}

/* async function manageAccount() {
   const functions = getFunctions(settings.globals.firebase.firebaseApp,"europe-west3");
    const functionRef = httpsCallable(functions, 'ext-firestore-stripe-subscriptions-createPortalLink');
    const { data } = await functionRef({ returnUrl: window.location.origin });
    window.location.assign(data.url);
 } */
async function manageAccount() {
    // Billing portal handler
    showSpinner();
    const functionLocation = 'us-west3';

    const functionRef = firebase
        .app()
        .functions(functionLocation)
        //.httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink'); //this uses the old name
        .httpsCallable('ext-firestore-stripe-payments-createPortalLink');
    const { data } = await functionRef({ returnUrl: window.location.origin });
    hideSpinner();
    window.location.assign(data.url);
}

/**
 * Ensure the Firestore user document exists and set settings.globals.firebase.isFirstLogin:
 * - First time (no doc or doc has no firstLoginAt): create/update doc with firstLoginAt, set isFirstLogin = true → app opens Help.
 * - Returning (doc has firstLoginAt): set isFirstLogin = false → app opens Dashboard.
 * Works with pre-created accounts: admin can create Auth users (and optionally user docs) in advance;
 * the app only sets firstLoginAt when the user actually logs in for the first time.
 */
async function ensureUserDocAndSetFirstLoginFlag(firebaseUser) {
    settings.globals.firebase.isFirstLogin = false;
    const db = settings.globals.firebase.db;
    if (!db || !firebaseUser || !firebaseUser.uid) return;

    const uid = firebaseUser.uid;
    const userRef = db.collection('users').doc(uid);
    const FieldValue = firebase.firestore.FieldValue;

    try {
        const snap = await userRef.get();
        if (!snap.exists) {
            await userRef.set({
                firstLoginAt: FieldValue.serverTimestamp(),
                createTimestamp: FieldValue.serverTimestamp(),
                updateTimestamp: FieldValue.serverTimestamp(),
            });
            settings.globals.firebase.isFirstLogin = true;
        } else {
            const data = snap.data();
            if (!data.firstLoginAt) {
                await userRef.update({
                    firstLoginAt: FieldValue.serverTimestamp(),
                    updateTimestamp: FieldValue.serverTimestamp(),
                });
                settings.globals.firebase.isFirstLogin = true;
            }
        }
    } catch (err) {
        console.error('ensureUserDocAndSetFirstLoginFlag:', err);
        settings.globals.firebase.isFirstLogin = false;
    }
}

/**
 * Handle showing content after user logs in (called from ongoing auth state listener)
 * COMMENTED OUT: Previous version only showed/hid content - now triggers full initialization if needed
 * Previously: Only showed content, assumed initialization would happen elsewhere
 * Now: If map isn't initialized yet, dispatches event to trigger initialization
 */
function handlePostLoginInitialization() {
    const map = document.getElementById('map');
    const header = document.querySelector('#Header');

    // If content is hidden, show it now (user just logged in)
    if (map) {
        // Show main content
        if (map.style.display === 'none') map.style.display = '';
        if (header && header.style.display === 'none') header.style.display = '';
        // LeftBarContainer visibility will be managed by layer system

        // Hide login container
        const loginContainer = document.querySelector('#myFirebaseUI-Container');
        if (loginContainer) loginContainer.style.display = 'none';

        // Set authenticated attribute
        document.querySelector('html').setAttribute('data-authenticated', 'true');

        const siteTitleEl = document.getElementById('siteTitleLineOne');
        if (siteTitleEl) {
            siteTitleEl.innerHTML = htmlBuilder.getSiteTitleBlockHtml();
        }

        // NEW: If map isn't initialized yet, trigger initialization via custom event
        // This happens when user logs in after the initial page load
        // The initialization.js will listen for this event and complete initialization
        if (!settings.globals.map) {
            console.log('Map not initialized yet, dispatching initialization event');
            const firebaseUser = settings.globals.firebase.firebaseApp.auth().currentUser;
            const initEvent = new CustomEvent('userAuthenticated', {
                detail: { needsInitialization: true, firebaseUser },
            });
            window.dispatchEvent(initEvent);
        } else {
            // Map is already initialized, just switch to the callback layer if set
            if (settings.globals.firebase.callBackLayerIndex !== null) {
                htmlBuilder.switchModes(settings.globals.firebase.callBackLayerIndex);
                settings.globals.firebase.callBackLayerIndex = null; // Clear callback
            }
        }
    }
}

/**
 * Handle logout - hide content and show login
 */
/**
 * Handle logout - hide main content and show login
 * COMMENTED OUT: Previous version hid everything - now shows LeftBarContainer for login form
 * Previously: Hid all content including LeftBarContainer
 * Now: Hides map and header, but keeps LeftBarContainer visible to show login form
 */
function handleLogout() {
    const map = document.getElementById('map');
    const header = document.querySelector('#Header');

    // Hide main content (map and header)
    if (map) map.style.display = 'none';
    if (header) header.style.display = 'none';
    // LeftBarContainer stays visible to show login form

    // Show login container (inside LeftBar)
    const loginContainer = document.querySelector('#myFirebaseUI-Container');
    if (loginContainer) {
        loginContainer.style.display = 'block';
        // Trigger login UI setup
        handleLogInAndSubscribe();
    } else {
        // If login container doesn't exist, build it
        // This should rarely happen, but handle it as fallback
        console.warn('Login container not found on logout, attempting to build');
        // Note: buildSubscribe needs to be called, but we don't have direct access here
        // This will be handled by the layer system or initialization
    }
}

export {
    handleLogInAndSubscribe,
    handleEmailPasswordSignIn,
    manageAccount,
    initFirebase,
    mySignOut,
    showSpinner,
    hideSpinner,
    ensureUserDocAndSetFirstLoginFlag,
};
